// @TODO: combine with listitem?
/**
 * Ryan O'Dowd
 * 2023-08-23
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useEffect,
  useState,
} from 'react';
import {
  TouchableOpacity,
  View,
} from 'react-native';
import Badge from '@components/common/Badge';
import Icon from '@react-native-vector-icons/material-design-icons';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Accordion = (_p: AccordionProps) => {
  const props = {
    ...defaultProps,
    ..._p,
  };
  const styles = hooks.useStyles(getStyles, {theme: props.theme});

  const [_isExpanded, setIsExpanded] = useState(props.defaultOpen);

  useEffect(() => {
    if (props.openIfClosed && !props.disabled) {
      setIsExpanded(true);
    } else if (props.closeIfOpen) {
      setIsExpanded(false);
    }
  }, [props.openIfClosed, props.closeIfOpen, props.disabled]);

  return (
    <View style={[styles.container, props.containerStyles]}>
      <TouchableOpacity
        style={[styles.touchableAccordion, props.disabled && styles.disabled]}
        onPress={() => {
          setIsExpanded((curr) => {
            props.onChange?.(!curr);
            return props.expandable ? !curr : curr;
          });
        }}
        disabled={props.disabled || (!props.expandable && !props.onChange)}
      >
        <View style={styles.row}>
          {props.leftItem &&
            <View style={styles.leftItemWrapper}>
              {props.leftItem}
            </View>
          }
          <View style={[styles.titleAndSubtitle, !!props.leftItem && styles.noLeftMargin]}>
            {typeof props.title === 'object' ? props.title : <Text style={styles.titleText}>{props.title}</Text>}{/* @TODO: add progress ring */}
            {props.subtitle
              ? (typeof props.subtitle === 'object' ? props.subtitle : <Text style={styles.subtitleText}>{props.subtitle}</Text>)
              : null
            }
          </View>
        </View>
        {/* @TODO:
        <ProgressBar
          style={styles.TODO}
          progress={Math.random()}
          color={styles.colors.accent}
        />{/* @TODO: don't hardcode /}
        {/* @TODO: display tooltips for start_date, end_date, current_date, and current_progress...maybe have db column for some "sub goals" to hide the current_progress (for example, not expecting kids to have 4 chapters memorized by october 1...that's more of a student deadline than a memorization one) /}
        */}
        {props.rightItem &&
          <View style={[styles.rightItemWrapper, props.rightItemFloatTop && styles.alignWithTop]}>
            {props.rightItem}
          </View>
        }
        {props.expandable &&
          <View style={styles.rightItemWrapper}>
            {/* @TODO: animate chevron */}
            <Icon name={_isExpanded ? 'chevron-up' : 'chevron-down'} size={styles.globalScale * 24} color={props.theme === 'white' ? styles.colors.primaryExtraDark : styles.colors.primaryExtraLight} />
          </View>
        }
      </TouchableOpacity>
      {_isExpanded &&
        <View style={[styles.childrenWrapper, props.childrenWrapperStyles]}>
          {props.children}
        </View>
      }
      {props.hasBadge && <Badge color={props.badgeColor}>{props.badgeText}</Badge>}
    </View>
  );
};

class AccordionProps {
  children: React.ReactNode;
  title: string | React.ReactNode;

  subtitle?: string | React.ReactNode;
  childrenWrapperStyles?: any; // @TODO: need this?
  containerStyles?: any; // @TODO: need this?
  defaultOpen?: boolean;
  openIfClosed?: boolean;
  closeIfOpen?: boolean;
  rightItem?: any;
  rightItemFloatTop?: boolean;
  disabled?: boolean;
  expandable?: boolean = true; // @NOTE: not the same as disabled; this will hide the chevron, prevent open/close toggle onpress, but still allows onChange to be called
  leftItem?: any;
  theme?: 'white' | 'primary' | 'completed' = 'primary';
  onChange?: (open: boolean) => void;
  hasBadge?: boolean;
  badgeText?: string;
  badgeColor?: string;
};
const defaultProps = new AccordionProps();

export default Accordion;
